import styled from "styled-components";
import { palette } from "../../styles/palette";

// Alerta para móviles (no se puede cerrar)
export const MobileAlertOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 5000;
  background: ${palette.overlayLight};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const MobileAlertCard = styled.div`
  background: ${palette.white};
  border-radius: 8px;
  padding: 24px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 4px 16px ${palette.shadowLight};
  position: relative;
`;

export const MobileAlertTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: ${palette.grenTitle};
  margin-bottom: 16px;
  text-align: center;
`;

export const MobileAlertMessage = styled.div`
  font-size: 16px;
  color: ${palette.secondaryTextColor};
  line-height: 1.5;
  margin-bottom: 20px;
  text-align: center;
`;

export const MobileAlertInstruction = styled.div`
  font-size: 15px;
  color: ${palette.grenTitle};
  line-height: 1.4;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 500;
`;

export const AcademyButton = styled.a`
  width: 100%;
  background: ${palette.grenTitle};
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 16px;
  text-decoration: none;
  display: block;
  text-align: center;

  &:hover {
    background: ${palette.textGreenTitle};
    transform: translateY(-1px);
    color: white;
    text-decoration: none;
  }

  &:active {
    transform: translateY(0);
  }

  &:visited {
    color: white;
  }
`;
